import { createGlobalStyle, css } from "styled-components";

export const StyledSlideLeftRight = createGlobalStyle<{
  $direction: "left" | "right";
}>`

${(props) =>
  props.$direction === "left" &&
  css`
    &.c-slide-enter {
      position: absolute;
      transform: translateX(100%);
    }
    &.c-slide-enter-active {
      transform: translateX(0%);
      transition: all 200ms ease;
    }
    &.c-slide-exit {
      position: absolute;
    }
    &.c-slide-exit-active {
      transform: translateX(-100%);
      transition: all 200ms ease;
    }
  `}

  ${(props) =>
    props.$direction === "right" &&
    css`
      &.c-slide-enter {
        position: absolute;
        transform: translateX(-100%);
      }
      &.c-slide-enter-active {
        transform: translateX(0%);
        transition: all 200ms ease;
      }

      &.c-slide-exit {
        position: absolute;
      }

      &.c-slide-exit-active {
        transform: translateX(100%);
        transition: all 200ms ease;
      }
    `}

`;
